export const BASE_URL = "https://api.departsante.com"; //PROD
// export const BASE_URL = "http://localhost:3001"; //DEV
